import type { ChatMessage } from "@/zapi-frontend/stores/chatStore";

export type TDocumentsReadSummary = { read: number; total: number };

// What the done line says about a batch: how many of its files could be read. Nothing when none could;
// each unreadable file already says so on its own row.
export const summarizeDocumentsRead = (documents: { read: boolean }[]): TDocumentsReadSummary | null => {
  const read = documents.filter((d) => d.read).length;
  return read > 0 ? { read, total: documents.length } : null;
};

// The done line sits under the files it is about: right after their bubble when the chat has one,
// else just before the reply on its way, else at the end.
export const insertDocumentsReadLine = (
  messages: ChatMessage[],
  line: ChatMessage,
  { afterId, beforeId }: { afterId?: string | null; beforeId?: string | null }
): ChatMessage[] => {
  const afterIndex = afterId ? messages.findIndex((m) => m.id === afterId) : -1;
  if (afterIndex >= 0) return [...messages.slice(0, afterIndex + 1), line, ...messages.slice(afterIndex + 1)];
  const beforeIndex = beforeId ? messages.findIndex((m) => m.id === beforeId) : -1;
  if (beforeIndex >= 0) return [...messages.slice(0, beforeIndex), line, ...messages.slice(beforeIndex)];
  return [...messages, line];
};
